import phiz from '@/utils/phiz.js'
// import base64 from './base64.js'
const realurl = (bt, domain, au) => {
    //拼接导航地址
    let url = 'javascript:;';
    for (let u in domain) {
        let n = bt.toLocaleLowerCase() + 'Domain'
        // if (u.indexOf(bt.toLocaleLowerCase()) == 0 ) {
            url = domain[n] + au
        // }
    }
    return url
}

const realcontent = (txt) => {
    if (txt) {
        //转换表情
        return phiz.qqFaceImgMap(txt)
    }
}

const audioduration = (res) => {
    if (res) {
        let duration = JSON.parse(res).Duration
        return Math.ceil(duration / 1000) + '"'
    }

}

const durationtowidth = (res) => {
    if (res) {
        let duration = JSON.parse(res).Duration
        duration = Math.ceil(duration / 1000);
        if (duration >= 60) {
            duration = 'width:210px'
        } else {
            let w = duration / 60 * 130 + 80;
            duration = 'width:' + w + 'px';
        }
        return duration
    }

}

const timestampToTime = (timestamp) => {
    let timen = JSON.stringify(timestamp).length >10 ? timestamp:timestamp * 1000
    var date = new Date(timen);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y+M+D+h+m+s;
}
const time = (s) => {
    let MM = Math.floor(s / 60);
    let SS = s % 60;
    if (MM < 10)
        MM = "0" + MM;
    if (SS < 10)
        SS = "0" + SS;
    let min = MM + ":" + SS;
    return min.split('.')[0];
}

export {
    realurl,
    realcontent,
    audioduration,
    durationtowidth,
    time,
    timestampToTime
}



// WEBPACK FOOTER //
// ./src/utils/filters.js